module.exports = __webpack_public_path__ + "static/img/refill.6af45fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/refill.jpg
// module id = Ke+e
// module chunks = 1